import http from './ajax';

const API_URL = {
  courseUrl: '/Course',
};

class Api extends http {
  // eslint-disable-next-line no-unused-vars
  getAllCourse = async (params) => {
    const url = `${API_URL.courseUrl}/List?count=10&leaf=${params}`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }

  getCourseDetail = async (params) => {
    const url = `${API_URL.courseUrl}/${params}`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }

  getInquireRegistration = async (params = {}) => {
    const url = `${API_URL.courseUrl}/Participant/Search/${params.Name}?courseTitle=${params.Title}&office=${params.Company}&number=${params.Number}&count=100&leaf=1`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }

  getInquireTraining = async (params = {}) => {
    const url = `${API_URL.courseUrl}/Search?number=${params.Number}&title=${params.Title}&count=100&leaf=1`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }

  postRegister = async (params = {}) => {
    const url = `${API_URL.courseUrl}/Participant/Create`;
    try {
      const response = await this.postRequest(url, params);
      return response;
    } catch (err) {
      return err;
    }
  }

  getCourseDisplayColumns = async (params) => {
    const url = `${API_URL.courseUrl}/Participant/DisplayColumns?Id=${params}`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }
}

export default new Api();
